<template>
  <div class="controlItemWrapper" :class="control.className" :data-control-name="control.name">
    <div class="controlItem row" :id="control.name" v-if="labelPosition === 'left'">
      <div class="col-md-4">
        <label
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        >{{control.label}}</label>
      </div>
      <div class="col-md-8 input-group">
        <multiselect
          v-model="selectedLookUps"
          :options="lookups"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :searchable="true"
          placeholder
          label="text"
          selectedLabel
          track-by="value"
          :disabled="control.readonly"
          openDirection="bottom"
        />
      </div>
    </div>
    <div class="controlItem row" :id="control.name" v-else>
      <div class="form-group col-md-12">
        <label
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        >{{control.label}}</label>
        <div>
          <multiselect
            v-model="selectedLookUps"
            :options="lookups"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            :searchable="true"
            placeholder
            label="text"
            selectedLabel
            track-by="value"
            :disabled="control.readonly"
            openDirection="bottom"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { find as lodashFind } from 'lodash'
// services
import db from '@/services/db'

export default {
  props: ['control', 'labelPosition'],
  data() {
    return {
      lookUpTable: null,
      selectedLookUps: [],
    }
  },
  computed: {
    ...mapState(['dataGrid_options']),
    lookUpTableDisplayColumn() {
      return this.dataGrid_options[this.lookUpTable].displayColumn
    },
    lookups() {
      const lookups = []
      const lookUpTableVals = $getGrid(this.lookUpTable)

      if (lookUpTableVals) {
        lookUpTableVals.map(row => {
          lookups.push({
            text: row[this.lookUpTableDisplayColumn],
            value: row.rowKey,
          })
        })
      }

      return lookups
    },
  },
  created() {
    this.$nextTick(() => {
      const formBuilderInst = this.$instByClass(this, 'form-builder-root')
      const meta = this.dataGrid_options[formBuilderInst.gridId].meta[
        this.control.propName
      ]

      if (meta) this.lookUpTable = meta.lookUpTable
    })
  },
}
</script>